import { SearchContext } from '@/hooks/use-search-context';
import { ReactNode, useState } from 'react';

export default function SearchProvider({ children }: { children: ReactNode }) {
    const [query, setQuery] = useState('');
    const [adults, setAdults] = useState(2);
    const [childrenCount, setChildrenCount] = useState(0);
    const [rooms, setRooms] = useState(1);

    return (
        <SearchContext.Provider
            value={{
                query,
                setQuery,
                adults,
                setAdults,
                children: childrenCount,
                setChildren: setChildrenCount,
                rooms,
                setRooms,
            }}
        >
            {children}
        </SearchContext.Provider>
    );
}
